import React from 'react';
import StructureContent from './Components/structure';


const Structure = () => {
 
  return (
    <div>
      <StructureContent />
    </div>
  );
};

export default Structure;